import PropTypes from 'prop-types';
import React from 'react';
import Layout from '../../../components/Layout';
import Loading from '../../../components/Loading';
import Error from '../../../components/Error';
import HotelList from './HotelList';
import SearchHotelForm from './SearchHotelForm';

class BrowseHotel extends React.Component {
  componentWillMount() {}
  componentWillReceiveProps(nextProps) {}

  render() {
    if (this.props.hasError) {
      return (
        <Layout>
          <Error />
        </Layout>
      );
    }
    if (this.props.needFetch) {
      return (
        <Layout>
          <Loading />
        </Layout>
      );
    }
    if (this.props.id) {
      return (
        <Layout>
          <div>{this.props.children}</div>
        </Layout>
      );
    }
    return (
      <Layout>
        <div className="content-tours">
          <div className="container-fluid">
            <div className="row tour-head">
              <div className="col-md-12 tour-headText">
                <h2>Search Hotels</h2>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-md-12">
                <SearchHotelForm requestHotelSearch={this.props.requestHotelSearch} />
              </div>
              <div className="col-md-12">
                <p>
                  Browse hotels. <span />
                </p>
              </div>
            </div>
            {this.props.isFetching && <Loading />}
            {!this.props.isFetching && (
              <HotelList
                hotels={this.props.hotels}
                requestHotelClaim={() => {}}
                viewHotel={this.props.viewBrowseHotel}
                readOnly
                managed
              />
            )}
          </div>
        </div>
      </Layout>
    );
  }
}

BrowseHotel.propTypes = {
  id: PropTypes.string.isRequired,
  needFetch: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  hasError: PropTypes.bool.isRequired,
  children: PropTypes.node,
  hotels: PropTypes.arrayOf(PropTypes.object),
  requestHotelSearch: PropTypes.func.isRequired,
  viewBrowseHotel: PropTypes.func.isRequired,
};
BrowseHotel.defaultProps = {
  hotels: null,
  children: null,
};

export default BrowseHotel;



// WEBPACK FOOTER //
// src/routes/hotels/components/BrowseHotels.js